import { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import RestrictedContent from '../../../core/components/router/RestrictedContent';
import TableHeadCell from '../../../core/components/table/TableHeadCell';
import { TableHeadCellTitle } from './ProductTables/ProductCompatibilityTable';
import styles from './ProductHeaderCells.module.css';

const ProductHeaderCells = ({
    isLoggedIn,
    showCustomerPrice,
    showDiscountColumn,
    showBackordersColumn,
}: {
    isLoggedIn: boolean;
    showCustomerPrice: boolean;
    showDiscountColumn?: boolean;
    showBackordersColumn?: boolean;
}) => {
    const intl = useIntl();

    const availabilityHeader =
        intl.locale !== 'de' ? (
            intl.formatMessage({ id: 'availability' })
        ) : (
            // cspell:words Verfüg, barkeit
            <>Verfüg&#173;barkeit</>
        );

    return (
        <>
            {isLoggedIn && (
                <>
                    <TableHeadCell data-test-class="ProductsTableAvailabilityColumnHeader">
                        <TableHeadCellTitle>
                            {availabilityHeader}
                        </TableHeadCellTitle>
                    </TableHeadCell>
                    {showBackordersColumn && (
                        <TableHeadCell className={styles.backOrderCell}>
                            <TableHeadCellTitle>
                                <FormattedMessage id="backorder short" />
                            </TableHeadCellTitle>
                        </TableHeadCell>
                    )}
                </>
            )}
            <TableHeadCell>
                <TableHeadCellTitle messageId="recommended retail price" />
            </TableHeadCell>
            {isLoggedIn && (
                <>
                    {showCustomerPrice && (
                        <>
                            <TableHeadCell>
                                <TableHeadCellTitle
                                    normalText
                                    messageId="my dealer price"
                                />
                            </TableHeadCell>
                            {showDiscountColumn && (
                                <TableHeadCell>
                                    <TableHeadCellTitle messageId="discount" />
                                </TableHeadCell>
                            )}
                        </>
                    )}
                </>
            )}
            <RestrictedContent
                storeFlags={isLoggedIn ? undefined : 'cartSharingEnabled'}
            >
                <TableHeadCell>
                    <TableHeadCellTitle messageId="amount" />
                </TableHeadCell>
            </RestrictedContent>
        </>
    );
};

export default memo(ProductHeaderCells);
